module.exports = __webpack_public_path__ + "static/media/lotus.bc8dc308.png";